module.exports = __webpack_public_path__ + "img/nextspin-btn.078df5d7.png";